import {Component, EventEmitter, Input, Output} from "@angular/core";

@Component({
	selector: 'cp-notifications-bar-tile',
	styleUrls: ['./notifications.bar.tile.style.scss'],
	templateUrl: './notifications.bar.tile.template.html'
})
export class NotificationsBarTileComponent {
	@Input() level:'warn'|'info'='warn';
	@Input() text: string;
	@Input() textParameter: string;
	@Input() showCloseButton: boolean;

	@Output() close: EventEmitter<boolean> = new EventEmitter<boolean>();
}
